/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ResourceInventoryLocation extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("ResourceInventoryLocation");
    }

    getFixupPrototypeFunction() { return ResourceInventoryLocation.fixupPrototype; }

    static newInstance(model: Partial<ResourceInventoryLocation>): ResourceInventoryLocation {
        let obj = Object.assign(new ResourceInventoryLocation(), model);
        ResourceInventoryLocation.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ResourceInventoryLocation>): ResourceInventoryLocation {
        if (!model) return null;
        return ResourceInventoryLocation.newInstance(<ResourceInventoryLocation> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ResourceInventoryLocation) {
        if (!obj) return;

        models.ResourceInventoryLocation.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ResourceInventoryLocation): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ResourceInventoryLocation.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Regions owning the resources, matched against the location field the record stores. These are the same values a distinct over location offers, so every value the filter accepts is one the caller can be shown.
     */
    locations: Array<string>;

}
